import  RestrictiveDirective from 'Directives/restrictiveDirective'


export default {
  install(Vue) {
    Vue.directive('restrictive', RestrictiveDirective)

  }
}
